<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog" id="muven-product-main-image-selection-modal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Escolha as imagens</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="muven-tip tip-info mb-3">
                                    <fa icon="info" class="tip-icon" />
                                    <p>O tamanho máximo das imagens aceito é de 5MB.</p>
                                    <p>As extensões aceitas são: JPG, JPEG ou PNG</p>
                                </div>
                            </div>

                            <div class="col-12 form-group">
                                <label>Escolha as imagens</label>
                                <input type="file" id="product-main-image-selection-input" class="form-control" multiple
                                    accept=".jpg,.jpeg,.png" @change="productMainImageForm.updateImages($event)" />
                            </div>

                            <div class="col-12 form-group">
                                <label>URL da imagem (opcional)</label>
                                <input type="text" class="form-control" v-model="productMainImageForm.url" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" :disabled="addingImagesToMainProduct"
                            @click="addImagesToMainProduct(productMainImageForm)">
                            Adicionar

                            <Loading v-show="addingImagesToMainProduct" />
                        </button>

                        <button type="button" class="btn btn-outline-secondary" :disabled="addingImagesToMainProduct"
                            @click="closeProductMainImageSelectionModal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="muven-product-variation-image-selection-modal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Escolha as imagens</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="muven-tip tip-info mb-3">
                                    <fa icon="info" class="tip-icon" />
                                    <p>O tamanho máximo das imagens aceito é de 5MB.</p>
                                    <p>As extensões aceitas são: JPG, JPEG ou PNG</p>
                                </div>
                            </div>

                            <div class="col-12 form-group">
                                <label>Escolha as imagens</label>
                                <input type="file" id="product-variation-image-selection-input" class="form-control"
                                    multiple accept=".jpg,.jpeg,.png"
                                    @change="productVariationImageForm.updateImages($event)" />
                            </div>

                            <div class="col-12 form-group">
                                <label>URL da imagem (opcional)</label>
                                <input type="text" class="form-control" v-model="productVariationImageForm.url" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" :disabled="addingImagesToVariation"
                            @click="addImagesToProductVariation(productVariationImageForm, chosenProductVariation)">
                            Adicionar

                            <Loading v-show="addingImagesToVariation" />
                        </button>

                        <button type="button" class="btn btn-outline-secondary" :disabled="addingImagesToVariation"
                            @click="closeProductVariationImageSelectionModal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <ProductFormWarningCmp ref="productFormWarning" @confirm="newAllowImportFromWarningHandler" />

        <ProductIntegrationDiagnosticCmp
            ref="integrationDiagnostic"
            variant="edicao"
            :loading="loading"
            :blocked="!productForm.hasChannels()"
            :product="productForm.getSourceProduct()"
            :backend-name="subscriber.getBackendName()"
            :channel-list="channelList"
            :is-backend-shop="subscriber.isBackendShop()"
            :audit-url="getAuditUrl(productForm.getId(), EntityEnum.Product)" />

        <div class="muven-card" v-if="!loading">
            <div class="muven-card-loading" v-show="submittingProduct">
                <div class="muven-card-loading-message-container">
                    <p class="loading-message">
                        <fa class="loading-icon" icon="sync-alt" spin />
                    </p>
                </div>
            </div>

            <div class="muven-card-title">
                <div class="float-right w-50" v-if="!subscriber.isBackendMuven()">
                    <multiselect v-model="productForm.allowImportWrapper" :options="allowImportOptions"
                        :multiple="false" :show-labels="false" :allow-empty="false" label="description" track-by="enum"
                        placeholder="" />
                </div>
                <p class="product-name" v-show="!!productForm.name">{{ productForm.name }}</p>
                <p class="product-name text-muted" v-show="!productForm.name">-</p>
            </div>

            <div class="muven-card-content muven-card-content-without-margin">
                <ul class="nav nav-tabs" id="product-form-tab">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#product-general">Geral</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#product-descriptions">Descrições</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#product-images">Imagens</a>
                    </li>
                    <li class="nav-item" v-if="product.hasVariations() || subscriber.isBackendMuven()">
                        <a class="nav-link" data-toggle="tab" href="#product-variations">Variações</a>
                    </li>
                    <li class="nav-item" @click="getCategoryList()">
                        <a class="nav-link" data-toggle="tab" href="#product-categories">Categorias</a>
                    </li>
                    <li class="nav-item" @click="getBrandList()">
                        <a class="nav-link" data-toggle="tab" href="#product-brand">Marca</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#product-seo">SEO</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#product-channels">Canais</a>
                    </li>
                </ul>

                <div class="tab-content">
                    <div class="tab-pane fade show active" id="product-general">
                        <div class="row">
                            <div class="col-12 col-md-6 form-group">
                                <label>Nome</label>
                                <input type="text" class="form-control" v-model="productForm.name">
                            </div>

                            <div class="col-12 col-md-3 form-group">
                                <label>SKU</label>
                                <input type="text" class="form-control" disabled v-model="productForm.skuCode">
                            </div>

                            <div class="col-12 col-md-3 form-group">
                                <label>Código retaguarda</label>
                                <input type="text" class="form-control" disabled v-model="productForm.codeSource">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-4 form-group">
                                <label>Código EAN</label>
                                <input type="text" class="form-control" v-model="productForm.eanCode" />
                            </div>

                            <div class="col-12 col-md-4 form-group">
                                <label>Código NCM</label>
                                <input type="text" class="form-control" v-model="productForm.ncmCode" />
                            </div>

                            <div class="col-12 col-md-4 form-group">
                                <label>Código ISBN</label>
                                <input type="text" class="form-control" v-model="productForm.isbnCode" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-3 form-group">
                                <label>Peso (kg)</label>
                                <input type="number" class="form-control" min="0" step="0.001"
                                    v-model="productForm.weight" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-3 form-group">
                                <label>Altura (cm)</label>
                                <input type="number" class="form-control" min="0" v-model="productForm.height" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-3 form-group">
                                <label>Largura (cm)</label>
                                <input type="number" class="form-control" min="0" v-model="productForm.width" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-3 form-group">
                                <label>Profundidade (cm)</label>
                                <input type="number" class="form-control" min="0" v-model="productForm.depth" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 form-group">
                                <label>URL do vídeo</label>
                                <input type="text" class="form-control" v-model="productForm.videoUrl" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="">
                                    <SwitchToggle :prop-check="productForm.isActive" :label-checked="'Produto ativo'"
                                        :label-unchecked="'Produto ativo'" @updated="productStatusHandler" />
                                </div>

                                <div class="">
                                    <SwitchToggle :prop-check="productForm.isPhysical" :label-checked="'Produto físico'"
                                        :label-unchecked="'Produto físico'" @updated="productPhysicalHandler" />
                                </div>

                                <div class="">
                                    <SwitchToggle :prop-check="productForm.showWithoutStock"
                                        :label-checked="'Exibir mesmo quando não houver estoque'"
                                        :label-unchecked="'Exibir mesmo quando não houver estoque'"
                                        @updated="productShowWithoutStockHandler" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="product-descriptions">
                        <div class="row">
                            <div class="col-12">
                                <div class="muven-tip tip-info mb-3">
                                    <fa icon="info" class="tip-icon" />
                                    <p><b>ATENÇÃO!</b></p>
                                    <p>Embora seja possível customizar o estilo das descrições com os componentes
                                        abaixo,
                                        alguns canais não aceitam estas modificações via API.</p>
                                    <p>Portanto, caso necessário, preencha apenas os dados de forma simples, sem
                                        customizações de estilo.</p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2 ml-auto">
                                <SwitchToggle :prop-check="rawDescriptions" :label-checked="'Descrições puras'"
                                    :label-unchecked="'Descrições puras'" @updated="toggleRawDescriptions" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 form-group">
                                <label>Descrição principal</label>
                                <textarea rows="10" v-show="rawDescriptions" class="form-control"
                                    v-model="productForm.description" @change="updateMainDescriptionEditor"></textarea>

                                <quill-editor ref="mainDescriptionQuill" v-show="!rawDescriptions"
                                    class="rich-text-editor" :content="productDescriptionsEditorMutable.main"
                                    :options="editorOptions" @change="onMainDescriptionChange($event)" />
                            </div>

                            <div class="col-12 form-group">
                                <label>Descrição curta</label>
                                <textarea rows="10" v-show="rawDescriptions" class="form-control"
                                    v-model="productForm.descriptionShort"
                                    @change="updateShortDescriptionEditor"></textarea>

                                <quill-editor ref="shortDescriptionQuill" v-show="!rawDescriptions"
                                    class="rich-text-editor" :content="productDescriptionsEditorMutable.short"
                                    :options="editorOptions" @change="onShortDescriptionChange($event)" />
                            </div>

                            <div class="col-12 form-group">
                                <label>Descrição longa</label>
                                <textarea rows="10" v-show="rawDescriptions" class="form-control"
                                    v-model="productForm.descriptionLong"
                                    @change="updateLongDescriptionEditor"></textarea>

                                <quill-editor ref="longDescriptionQuill" v-show="!rawDescriptions"
                                    class="rich-text-editor" :content="productDescriptionsEditorMutable.long"
                                    :options="editorOptions" @change="onLongDescriptionChange($event)" />
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="product-images">
                        <div class="image-actions-container">
                            <button class="btn btn-outline-secondary mr-3"
                                @click="openProductMainImageSelection()">Adicionar imagens</button>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="product-image-list-container">
                                    <div class="no-images" v-show="!productForm.hasImages()">
                                        <p class="text-muted">Nenhuma imagem encontrada</p>
                                    </div>

                                    <div class="product-image-container text-center"
                                        v-for="(img, index) in productForm.images.filter(img => !img.deletedAt)"
                                        :key="index">
                                        <img :src="img.url" alt="Imagem">
                                        <fa icon="sync-alt" spin class="icon-delete-image" v-show="img.beingDeleted" />
                                        <fa icon="trash-alt" class="icon-delete-image"
                                            @click="deleteProductMainImage(img)" v-show="!img.beingDeleted" />
                                        <p class="text-muted">{{ img.getSizeInformation() }}</p>
                                        <button class="btn mt-3" :class="{
                                            'btn-outline-primary': img.isMain && img.isActive,
                                            'btn-outline-secondary': !img.isMain || !img.isActive,
                                        }" :disabled="img.updatingMainAttribute" @click="setMainImage(img)">

                                            <span v-show="img.isMain && img.isActive">
                                                Principal

                                                <fa icon="check-circle" v-show="!img.updatingMainAttribute" />

                                                <Loading v-show="img.updatingMainAttribute" />
                                            </span>

                                            <span v-show="!img.isActive">
                                                Inativa

                                                <fa icon="ban" />
                                            </span>

                                            <span v-show="!img.isMain">
                                                <span v-show="img.isActive">
                                                    Tornar principal

                                                    <Loading v-show="img.updatingMainAttribute" />
                                                </span>

                                                <span v-show="!img.isActive">
                                                    Ativar

                                                    <Loading v-show="img.updatingActiveAttribute" />
                                                </span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="product-variations"
                        v-if="product.hasVariations() || subscriber.isBackendMuven()">
                        <div v-show="productForm.hasVariations() && !showVariationsPriceForm">
                            <div class="mb-3 pl-3">
                                <button class="btn btn-outline-secondary" @click="toggleVariationsPriceForm()">
                                    Atualizar preços
                                </button>
                            </div>
                        </div>

                        <div v-show="productForm.hasVariations() && showVariationsPriceForm">
                            <div class="row m-0" v-show="productForm.hasVariations()">
                                <div class="col-12 col-sm-2 form-group">
                                    <label>Preço de venda</label>
                                    <input class="form-control" type="number" min="0" step="0.01"
                                        v-model="variationPriceForm.sellPrice" />
                                </div>

                                <div class="col-12 col-sm-2 form-group">
                                    <label>Preço de listagem</label>
                                    <input class="form-control" type="number" step="0.01" min="0"
                                        v-model="variationPriceForm.listPrice" />
                                </div>

                                <div class="col-12 col-sm-2 form-group">
                                    <label>Preço de custo</label>
                                    <input class="form-control" type="number" step="0.01" min="0"
                                        v-model="variationPriceForm.costPrice" />
                                </div>

                                <div class="col">
                                    <label class="invisible-label">.</label>
                                    <button class="btn btn-outline-primary mr-3"
                                        @click="updateVariationsPrices(productForm, variationPriceForm)">
                                        Atualizar preços
                                    </button>

                                    <button class="btn btn-outline-secondary mr-3" @click="hideVariationsPriceForm()">
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div v-show="!productForm.hasVariations()">
                            <div class="row m-0">
                                <div class="col-12 col-md-3 form-group">
                                    <label>Variação 1</label>
                                    <input type="text" class="form-control" v-model="variationForm.name1" />
                                    <small class="text-muted">Exemplo: Cor</small>
                                </div>

                                <div class="col-12 col-md-9 form-group">
                                    <label>Opções para variação 1</label>
                                    <input type="text" class="form-control" v-model="variationForm.variation1" />
                                    <small class="text-muted">Exemplo: Verde, Vermelho, Azul...</small>
                                </div>
                            </div>

                            <div class="row m-0">
                                <div class="col-12 col-md-3 form-group">
                                    <label>Variação 2</label>
                                    <input type="text" class="form-control" v-model="variationForm.name2" />
                                    <small class="text-muted">Exemplo: Tamanho</small>
                                </div>

                                <div class="col-12 col-md-9 form-group">
                                    <label>Opções para variação 2</label>
                                    <input type="text" class="form-control" v-model="variationForm.variation2" />
                                    <small class="text-muted">Exemplo: 36, 37, 38, 39, 40, 41</small>
                                </div>
                            </div>

                            <div class="row mb-3 m-0">
                                <div class="col-12">
                                    <button class="btn btn-outline-secondary" @click="createGrid(variationForm)">
                                        Gerar variações
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="product-variations-container" v-show="productForm.hasVariations()">
                            <div class="product-variation" v-for="(gridRow, index) in productForm.variations"
                                :key="index">
                                <div class="row mb-3">
                                    <div class="col">
                                        <label>{{ productForm.getBidimensionalGridInfo().getFirstName() }}</label>
                                        <p>{{ gridRow.firstVariation }}</p>
                                    </div>

                                    <div class="col" v-show="!!productForm.getBidimensionalGridInfo().getSecondName()">
                                        <label>{{ productForm.getBidimensionalGridInfo().getSecondName() }}</label>
                                        <p>{{ gridRow.secondVariation }}</p>
                                    </div>

                                    <div class="col">
                                        <label>SKU</label>
                                        <p>{{ gridRow.skuCode }}</p>
                                    </div>

                                    <div class="col">
                                        <label>Código retaguarda</label>
                                        <p>{{ gridRow.codeSource | infoOrPlaceholder }}</p>
                                    </div>

                                    <div class="col">
                                        <label>Status</label>
                                        <div class="btn-group">
                                            <button class="btn btn-sm" :class="{
                                                'btn-secondary': gridRow.isActive,
                                                'btn-outline-secondary': !gridRow.isActive,
                                            }" @click="activateGridRow(gridRow)">
                                                Ativo
                                            </button>
                                            <button class="btn btn-sm" :class="{
                                                'btn-secondary': !gridRow.isActive,
                                                'btn-outline-secondary': gridRow.isActive,
                                            }" @click="inactivateGridRow(gridRow)">
                                                Inativo
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-3">
                                        <label>Peso (em KG)</label>
                                        <input type="text" class="form-control" v-model="gridRow.weight" />
                                    </div>

                                    <div class="col-3">
                                        <label>Altura (em cm)</label>
                                        <input type="text" class="form-control" v-model="gridRow.height" />
                                    </div>

                                    <div class="col-3">
                                        <label>Largura (em cm)</label>
                                        <input type="text" class="form-control" v-model="gridRow.width" />
                                    </div>

                                    <div class="col-3">
                                        <label>Profundidade (em cm)</label>
                                        <input type="text" class="form-control" v-model="gridRow.depth" />
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-3">
                                        <label>Preço de venda</label>
                                        <input type="number" class="form-control" step="0.01" min="0" disabled
                                            v-model="gridRow.sellPrice">
                                    </div>

                                    <div class="col-3">
                                        <label>Preço de listagem</label>
                                        <input type="number" class="form-control" step="0.01" min="0" disabled
                                            v-model="gridRow.listPrice">
                                    </div>

                                    <div class="col-3">
                                        <label>Preço de custo</label>
                                        <input type="number" class="form-control" step="0.01" min="0" disabled
                                            v-model="gridRow.costPrice">
                                    </div>

                                    <div class="col-3">
                                        <label>Código EAN</label>
                                        <input type="text" class="form-control" v-model="gridRow.eanCode">
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 product-variation-images-container">
                                        <label>Imagens</label>
                                        <div v-show="!!gridRow.images.length">
                                            <div class="variation-image text-center"
                                                v-for="(image, index) in gridRow.images" :key="index">
                                                <span class="text-muted variation-image-dimension">{{
                                                    image.getSizeInformation() }}</span>

                                                <img :src="image.url" alt="Imagem" />

                                                <fa icon="sync-alt" class="icon-delete-image" spin
                                                    v-show="image.beingDeleted" />

                                                <fa icon="trash-alt" class="icon-delete-image"
                                                    v-show="!image.beingDeleted"
                                                    @click="deleteProductVariationImage(gridRow, image)" />
                                            </div>

                                            <button class="btn btn-outline-secondary ml-3"
                                                @click="openProductVariationImageSelection(gridRow)">
                                                +
                                            </button>
                                        </div>

                                        <p class="text-muted" v-show="!gridRow.images.length">
                                            <button class="btn btn-outline-secondary"
                                                @click="openProductVariationImageSelection(gridRow)">
                                                +
                                            </button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="product-categories">
                        <div class="row">
                            <div class="col-12" v-show="loadingCategoryList">
                                <Loading />
                            </div>
                        </div>

                        <div class="row" v-show="!loadingCategoryList">
                            <div class="col-12 form-group">
                                <label>Categorias</label>
                                <multiselect v-model="productForm.categories" :options="categoryList" :multiple="true"
                                    :show-labels="false" label="name" track-by="id" placeholder="" />
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="product-brand">
                        <div class="row">
                            <div class="col-12" v-show="loadingBrandList">
                                <Loading />
                            </div>

                            <div class="col-12 col-md-6 form-group" v-show="!loadingBrandList">
                                <label>Marca</label>
                                <multiselect v-model="productForm.brand" :options="brandList" :multiple="false"
                                    :show-labels="false" label="name" track-by="id" placeholder="" />
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="product-channels">

                        <div class="channel-settings-container"
                            v-for="(variation, index) in productForm.variationsChannels" :key="index">
                            <div
                                class="channel-settings-name-container d-flex justify-content-between align-items-center">
                                <p>{{ variation.name }} </p>

                                <button @click="toogleVariation(variation)" class="btn btn-sm">
                                    <i class="fas"
                                        :class="{ 'fa-chevron-down': variation.collapsed, 'fa-chevron-up': !variation.collapsed }"></i>
                                </button>
                            </div>

                            <br>

                            <div v-show="!variation.collapsed" class="channel-settings-container"
                                v-for="(channel, index) in variation.channels" :key="index">
                                <div
                                    class="channel-settings-name-container d-flex justify-content-between align-items-center">
                                    <p>{{ channel.name }} <span v-if="channel.idExternalChannel">({{
                                        channel.idExternalChannel }})</span></p>

                                    <button @click="toggleChannel(channel)" class="btn btn-sm">
                                        <i class="fas"
                                            :class="{ 'fa-chevron-down': channel.collapsed, 'fa-chevron-up': !channel.collapsed }"></i>
                                    </button>
                                </div>

                                <div class="channel-settings-content" v-show="!channel.collapsed">
                                    <div class="row" v-show="worksWithPriceUponRequest(channel)">
                                        <div class="col-12 col-md-6">
                                            <SwitchToggle :prop-check="channel.priceUponRequest"
                                                :label-checked="'Preço sob consulta'"
                                                :label-unchecked="'Preço sob consulta'"
                                                @updated="channelPriceUponRequestHandler(channel, !channel.priceUponRequest)" />
                                        </div>
                                    </div>

                                    <div v-show="!channel.priceUponRequest">
                                        <div class="row mb-3">
                                            <div class="col">
                                                <label>Tipo de preço</label>&nbsp;&nbsp;
                                                <div class="btn-group">
                                                    <button class="btn btn-sm" :class="{
                                                        'btn-secondary': channel.isPriceTypePercentage(),
                                                        'btn-outline-secondary': channel.isPriceTypeValue(),
                                                    }" @click="updateChannelPriceTypeToPercentage(channel)">
                                                        Utilizar preço em porcentagem
                                                    </button>
                                                    <button class="btn btn-sm" :class="{
                                                        'btn-secondary': channel.isPriceTypeValue(),
                                                        'btn-outline-secondary': channel.isPriceTypePercentage(),
                                                    }" @click="updateChannelPriceTypeToValue(channel)">
                                                        Utilizar preço fixo
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row" v-show="channel.isPriceTypeValue()">
                                            <div class="col-12 col-md-4 form-group">
                                                <label>Preço de listagem em {{ channel.name }}</label>
                                                <input type="number" class="form-control" step="0.01" min="0"
                                                    v-model="channel.listPrice" />
                                            </div>

                                            <div class="col-12 col-md-4 form-group">
                                                <label>Preço de venda em {{ channel.name }}</label>
                                                <input type="number" class="form-control" step="0.01" min="0"
                                                    v-model.lazy="channel.sellPrice"
                                                    @change="updateSellPrice($event, index)" />
                                            </div>
                                        </div>

                                        <div class="row" v-show="channel.isPriceTypePercentage()">
                                            <div class="col-12 col-md-4">
                                                <div class="form-group">
                                                    <label>Variação de preço (em %)</label>
                                                    <input type="number" class="form-control" step="1" min="-100"
                                                        v-model="channel.pricePercentage" />
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-4">
                                                <div class="form-group">
                                                    <label>Valor centavos</label>
                                                    <SelectWrapperCmp
                                                        :show-remove-button="!!channel.priceDecimalsPreference"
                                                        @removed="handlePriceDecimalsPreferenceRemoved(channel)">
                                                        <template v-slot:select>
                                                            <multiselect v-model="channel.priceDecimalsPreference"
                                                                :options="priceDecimals" :multiple="false"
                                                                :show-labels="false"
                                                                :disabled="!channelHasPricePercentage(channel)"
                                                                placeholder="" />
                                                        </template>
                                                    </SelectWrapperCmp>
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-4" v-show="channelHasPricePercentage(channel)">
                                                <div class="form-group">
                                                    <label>Exemplo de preço de venda</label>
                                                    <p>{{ examplePriceVariation(channel) | currency }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-3">
                                        <div class="col-12 col-md-4 form-group">
                                            <label>DISPONIBILIDADE DE ESTOQUE (EM %)</label>
                                            <input type="number" class="form-control" step="0.01" min="0"
                                                v-model="channel.stockAvailability" />
                                        </div>
                                        <div class="col-12 col-md-6"
                                            style="position: relative; top: 30px; width: 2500px;">
                                            <button class="btn btn-primary"
                                                @click="replicateValueForAllChannels(channel)">
                                                Replicar para todos
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-md-4 pt-3">
                                            <SwitchToggle :prop-check="channel.hasMinimalStock"
                                                :label-checked="'Trabalhar com estoque mínimo'"
                                                :label-unchecked="'Trabalhar com estoque mínimo'"
                                                @updated="channelHasMinimalStockHandler(channel, !channel.hasMinimalStock)" />
                                        </div>

                                        <div class="col-12 col-md-4" v-show="channel.hasMinimalStock">
                                            <div class="form-group">
                                                <label>Estoque mínimo</label>
                                                <input type="number" class="form-control" step="1" min="0"
                                                    v-model="channel.minimalStock" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-4">
                                            <SwitchToggle :prop-check="channel.isActive"
                                                :label-checked="'Produto ativo'" :label-unchecked="'Produto ativo'"
                                                @updated="channelIsActiveHandler(channel, !channel.isActive)" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-4">
                                            <div class="channel-validity-wrapper"
                                                :class="{ 'is-invalid': !channel.validInChannel && !channel.validInChannelPendingSave }">

                                                <div class="channel-validity-header">
                                                    <span class="channel-validity-label">Validade no canal</span>
                                                    <div class="info-icon-wrapper">
                                                        <span class="info-icon">?</span>
                                                        <div class="info-tooltip">
                                                            <strong>O que é isso?</strong>
                                                            <p>
                                                                Quando a integração encontra erros na atualização de
                                                                estoque com o canal (produto não encontrado, em revisão,
                                                                suspenso, encerrado, ser fulfilment, etc),
                                                                o <strong>Muven</strong> marca o produto como <em>inválido</em> e para de
                                                                tentar enviá-lo automaticamente.
                                                            </p>
                                                            <p>
                                                                Nesses casos, você poderá reativá-lo manualmente, mas
                                                                deverá <strong>verificar
                                                                    antes</strong> se o produto realmente está válido no
                                                                canal - caso contrário,
                                                                ele será marcado como inválido outra vez no próximo envio.
                                                            </p>

                                                            <p>

                                                                Há situações em que estar inválido no canal afeta apenas a
                                                                atualização de

                                                                <em>estoque</em> - não de preço. Isso pode acontecer se, por
                                                                exemplo, o produto existir no canal mas estiver suspenso, bloqueado ou sob gestão do
                                                                fulfillment.
                                                            </p>
                                                            <p><strong>Importante:</strong> Por enquanto, essa configuração só é utilizada para o <em>Mercado Livre</em></p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Produto VÁLIDO: banco=true, sem pendência -->
                                                <div v-if="channel.validInChannel && !channel.validInChannelPendingSave"
                                                    class="valid-status">
                                                    ✅ Produto válido e, se possuir associação, será integrado
                                                    normalmente.
                                                </div>

                                                <!-- Produto INVÁLIDO: banco=false, usuário ainda não ativou -->
                                                <template
                                                    v-else-if="!channel.validInChannel && !channel.validInChannelPendingSave">
                                                    <SwitchToggle :prop-check="false"
                                                        :label-checked="'Produto válido no canal'"
                                                        :label-unchecked="'Produto inválido no canal'"
                                                        @updated="channelIsValidHandler(channel, !channel.validInChannel)" />
                                                    <div class="invalid-warning">
                                                        ⚠️ Este produto foi marcado como inválido pela automação.
                                                        Verifique o status no canal antes de reativar.
                                                    </div>
                                                </template>

                                                <!-- PENDENTE: usuário ativou mas ainda não salvou -->
                                                <template v-else-if="channel.validInChannelPendingSave">
                                                    <SwitchToggle :prop-check="true"
                                                        :label-checked="'Produto válido no canal'"
                                                        :label-unchecked="'Produto inválido no canal'"
                                                        @updated="channelCancelRevalidationHandler(channel)" />
                                                    <div class="pending-warning">
                                                        💾 Para revalidar o produto, salve as alterações.
                                                    </div>
                                                </template>

                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="tab-pane fade" id="product-seo">
                        <div class="row">
                            <div class="col-12 form-group">
                                <label>Título (SEO)</label>
                                <textarea class="form-control" v-model="productForm.seoTitle" rows="4"></textarea>
                            </div>

                            <div class="col-12 form-group">
                                <label>Descrição (SEO)</label>
                                <textarea class="form-control" v-model="productForm.seoDescription" rows="4"></textarea>
                            </div>

                            <div class="col-12 form-group">
                                <label>Palavras chave (SEO)</label>
                                <textarea class="form-control" v-model="productForm.seoKeywords" rows="4"></textarea>
                                <small class="text-muted">Separe as palavras por vírgula</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="muven-card-actions">
                <button class="btn btn-primary" @click="checkIfCanSubmit(productForm);" :disabled="submittingProduct">
                    Gravar
                    <Loading v-show="submittingProduct" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { cloneDeep, sumBy, uniqBy } from "lodash";
import modalService from "@/utils/services/ModalService";
import productService from "@/product/services/ProductService";
import categoryService from "@/category/services/CategoryService";
import brandService from "@/brand/services/BrandService";
import { ProductFormModel } from '@/product/models/ProductFormModel';
import { ProductImageFormModel } from '@/product/models/ProductImageFormModel';
import { fileToBase64 } from '@/utils/helpers/FileHelper';
import { ProductImageModel } from '../models/ProductImageModel';
import { ProductVariationFormModel } from '../models/ProductVariationFormModel';
import { ProductVariationPriceFormModel } from '../models/ProductVariationPriceFormModel';
import { infoOrPlaceholder } from "@/utils/filters/InformationOrPlaceholderFilter";
import { ChannelEnum, EntityEnum, ProductCustomPriceTypeEnum } from '@c2b/muven-commons';
import { priceDecimals } from "@/utils/constants/PriceDecimals"
import GetAuditUrl from '@/utils/mixins/GetAuditUrl'
import ProductFormWarningCmp from "./ProductFormWarningCmp"
import ProductIntegrationDiagnosticCmp from "./ProductIntegrationDiagnosticCmp"
import SelectWrapperCmp from '@/utils/components/SelectWrapperCmp'
import { mapState } from 'vuex';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import '@fortawesome/fontawesome-free/css/all.css';

const ID_MODAL_PRODUCT_MAIN_IMAGE_SELECTION = '#muven-product-main-image-selection-modal'
const ID_MODAL_UPDATE_VARIATION_IMAGES = '#muven-product-update-variation-images-modal'
const ID_MODAL_PRODUCT_VARIATION_IMAGE_SELECTION = '#muven-product-variation-image-selection-modal'

export default {
    name: 'ProductModificationView',
    props: {
        product: {
            type: ProductFormModel,
            default: new ProductFormModel(),
            required: true,
        },
        productDescriptionsEditor: {
            type: Object,
            required: true,
            default: {},
        },
        loading: {
            type: Boolean,
            default: true,
            required: true,
        },
        channelList: {
            type: Array,
            default: [],
            required: true,
        },
    },
    components: {
        ProductFormWarningCmp,
        ProductIntegrationDiagnosticCmp,
        SelectWrapperCmp,
        quillEditor,
    },
    mixins: [
        GetAuditUrl,
    ],
    data() {
        return {
            EntityEnum,
            priceDecimals,
            showVariationsPriceForm: false,
            loadingCategoryList: false,
            loadingBrandList: false,
            submittingProduct: false,
            updatingVariationsPricesBasedOnMainProduct: false,
            updatingVariationsImagesBasedOnMainProduct: false,
            addingImagesToVariation: false,
            addingImagesToMainProduct: false,
            initialAllowImportInfo: {},
            variationForm: new ProductVariationFormModel(),
            variationPriceForm: new ProductVariationPriceFormModel(),
            categoryList: [],
            brandList: [],
            allowImportOptions: ProductFormModel.getAllowImportOptions(),
            productForm: new ProductFormModel(),
            productMainImageForm: new ProductImageFormModel(),
            productVariationImageForm: new ProductImageFormModel(),
            chosenProductVariation: {},
            rawDescriptions: false,
            productDescriptionsEditorMutable: this.productDescriptionsEditor,
            editorOptions: {
                theme: 'snow',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote', 'code-block'],
                        ['link'],
                        [{ indent: '-1' }, { indent: '+1' }],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                    ],
                },
            }
        }
    },
    filters: {
        infoOrPlaceholder,
    },
    methods: {

        toogleVariation(variation) {
            variation.collapsed = !variation.collapsed;
        },

        toggleChannel(channel) {
            channel.collapsed = !channel.collapsed;
        },

        updateSellPrice(event, index) {
            const value = parseFloat(event.target.value) || 0;
            this.productForm.channels[index].sellPrice = value;
        },

        activateGridRow(gridRow) {
            gridRow.isActive = true
        },
        inactivateGridRow(gridRow) {
            gridRow.isActive = false
        },
        newAllowImportFromWarningHandler(allowImport) {
            this.productForm.setAllowImportWrapper(allowImport);
            this.submitProduct(this.productForm);
        },
        channelPriceUponRequestHandler(channel, info) {
            channel.priceUponRequest = info

            if (channel.priceUponRequest) {
                this.updateChannelPriceTypeToValue(channel)
                this.productForm.resetChannelPrices(channel)
            } else {
                this.updateChannelPriceTypeToPercentage(channel)
            }
        },
        channelHasMinimalStockHandler(channel, info) {
            channel.hasMinimalStock = info
        },
        replicateValueForAllChannels(channel) {
            const isPriceTypePercentage = channel.isPriceTypePercentage();

            for (let i = 0; i < this.productForm.channels.length; i++) {
                const currentChannel = this.productForm.channels[i];

                currentChannel.pricePercentage = isPriceTypePercentage ? channel.pricePercentage : null;
                currentChannel.priceDecimalsPreference = isPriceTypePercentage ? channel.priceDecimalsPreference : null;
                currentChannel.listPrice = isPriceTypePercentage ? null : channel.listPrice;
                currentChannel.stockAvailability = Number(channel.stockAvailability);
                // ok, isso é estranho que só uma coisa estranha mesmo!
                currentChannel.availableStockPercentage = Number(channel.stockAvailability);
            }

            this.$floatingAlert.success({
                message: 'Valores replicados para todos os canais com sucesso',
                timeVisible: 10000
            });
        }, channelIsActiveHandler(channel, info) {

            channel.isActive = info
        },
        channelIsValidHandler(channel, info) {
            channel.validInChannel = info
            this.$set(channel, 'validInChannelPendingSave', true)
        },

        channelCancelRevalidationHandler(channel) {
            channel.validInChannel = false
            this.$set(channel, 'validInChannelPendingSave', false)
        },

        checkIfCanSubmit(product) {

            // Eduardo: Faço a substituição dos channels pelo que
            // eu alimentei no método setChannels(channelList: ChannelModel[]):void
            // em ProductFormModel.ts
            product.channels = product.variationsChannels.map(variation => variation.channels).flat();

            if (!product.hasChannels()) {
                // O painel usa v-if, então pode não estar montado se o bloqueio do
                // salvamento e a condição de exibição divergirem.
                const diagnostic = this.$refs.integrationDiagnostic;

                this.$floatingAlert.error({
                    message: diagnostic
                        ? diagnostic.getBlockedSaveMessage()
                        : "Não é possível salvar: este produto não está vinculado a nenhum canal. " +
                            "Veja o diagnóstico de integração no topo da página.",
                    timeVisible: 10000,
                });

                if (diagnostic) {
                    diagnostic.expand();
                }

                return;
            }

            if (product.isAllowImportAll() && !this.subscriber.isBackendMuven()) {
                this.$refs.productFormWarning.show();
                return;
            }

            this.submitProduct(product);
        },
        handlePriceDecimalsPreferenceRemoved(channel) {
            channel.priceDecimalsPreference = null
        },
        updateMainDescriptionEditor({ target }) {
            this.$refs.mainDescriptionQuill.quill.pasteHTML(target.value);
        },
        updateShortDescriptionEditor({ target }) {
            this.$refs.shortDescriptionQuill.quill.pasteHTML(target.value);
        },
        updateLongDescriptionEditor({ target }) {
            this.$refs.longDescriptionQuill.quill.pasteHTML(target.value);
        },
        onMainDescriptionChange({ html }) {
            this.productDescriptionsEditorMutable.main = html;
            this.productForm.setDescription(html);
        },
        onShortDescriptionChange({ html }) {
            this.productDescriptionsEditorMutable.short = html;
            this.productForm.setDescriptionShort(html);
        },
        onLongDescriptionChange({ html }) {
            this.productDescriptionsEditorMutable.long = html;
            this.productForm.setDescriptionLong(html);
        },
        async submitProduct(product) {

            for (let i = 0; i < product.channels.length; i++) {
                const currentChannel = product.channels[i];
                currentChannel.availableStockPercentage = Number(currentChannel.stockAvailability);
            }

            this.$floatingAlert.hide();
            this.submittingProduct = true;

            try {
                const productNormalized = ProductFormModel.normalizeBeforeSubmit(product);
                const productResponse = await productService.createOrUpdate(productNormalized);
                this.productForm = new ProductFormModel(productResponse);
                let message = "Produto criado com sucesso!";

                if (productNormalized.hasId()) {
                    message = "Produto atualizado com sucesso!"
                }

                this.$floatingAlert.success({
                    message,
                });

                if (!!productResponse.parent) {
                    this.$router.push(`/produtos/${productResponse.parent.id}`);
                } else {
                    this.$router.push(`/produtos/${productResponse.id}`);
                }
            } catch (e) {
                this.$floatingAlert.error({ message: e.message });
            }

            this.submittingProduct = false;
        },
        updateVariationsPrices(productForm, variationPriceForm) {
            productForm.updateVariationsPrices(variationPriceForm)
            this.hideVariationsPriceForm()
        },
        toggleVariationsPriceForm() {
            this.showVariationsPriceForm = !this.showVariationsPriceForm
        },
        hideVariationsPriceForm() {
            this.showVariationsPriceForm = false
        },
        async deleteProductMainImage(image) {
            image.beingDeleted = true;

            try {
                await productService.deleteProductImages(this.productForm.getId(), [image.id])
            } finally {
                image.beingDeleted = false;
            }

            this.productForm.deleteImage(image);
        },
        async deleteProductVariationImage(variation, image) {
            image.beingDeleted = true

            try {
                await productService.deleteProductImages(variation.id, [image.id]);
            } finally {
                image.beingDeleted = false;
            }

            this.productForm.deleteVariationImage(variation, image);
        },
        updateChannelPriceTypeToPercentage(channel) {
            channel.updatePriceType(ProductCustomPriceTypeEnum.Percentage)
        },
        updateChannelPriceTypeToValue(channel) {
            channel.updatePriceType(ProductCustomPriceTypeEnum.Value)
        },
        async addImagesToMainProduct(productMainImageForm) {
            if (!productMainImageForm.hasImages()) {
                return
            }

            let files = []

            if (productMainImageForm instanceof ProductImageFormModel) {
                files = productMainImageForm.getFiles()
            }

            for (const file of files) {
                const fileText = await fileToBase64(file);
                const imageInfo = fileText.split(";base64,");
                this.productForm.addNewImageList(new ProductImageModel({
                    url: fileText,
                    byteLength: file.size,
                    isMain: this.productForm.hasImages() ? false : true,
                    isActive: true,
                    imageInfo: imageInfo[1],
                }));
            }

            if (this.productMainImageForm.hasUrl()) {
                this.productForm.addNewImageList(new ProductImageModel({
                    url: productMainImageForm.url,
                    byteLength: 0,
                    isMain: this.productForm.hasImages() ? false : true,
                    isActive: true,
                    imageInfo: productMainImageForm.url,
                }));
            }

            const newImageList = this.productForm.getSubmittableImageList();

            for (const img of newImageList) {
                if (img.sizeMb >= ProductImageFormModel.MAX_SIZE_MB) {
                    this.$floatingAlert.error({
                        title: '',
                        message: `Algumas imagens escolhidas ultrapassam o tamanho máximo aceito de ${ProductImageFormModel.MAX_SIZE_MB}mb.`
                    })

                    productMainImageForm.clear()
                    this.productForm.clearNewImageList()

                    return
                }
            }

            this.addingImagesToMainProduct = true;

            try {
                const totalMainProductImageListSize = sumBy(newImageList, 'sizeMb')

                if (totalMainProductImageListSize < ProductImageFormModel.MAX_SIZE_MB) {
                    const images = await productService.createProductImages(this.productForm.getId(), newImageList)
                    this.productForm.setImages(images)
                } else {
                    for (const img of newImageList) {
                        const images = await productService.createProductImages(this.productForm.getId(), [img])
                        this.productForm.setImages(images)
                    }
                }

                this.productForm.clearNewImageList();
                this.closeProductMainImageSelectionModal()
            } catch (err) {
                this.$floatingAlert.error({
                    message: `Houve um problema ao tentar adicionar imagens ao produto.`
                })
            }

            this.addingImagesToMainProduct = false;
        },
        async addImagesToProductVariation(productVariationImageForm, chosenProductVariation) {
            if (!productVariationImageForm.hasImages()) {
                return
            }

            this.addingImagesToVariation = true

            let files = []

            if (productVariationImageForm instanceof ProductImageFormModel) {
                files = productVariationImageForm.getFiles()
            }

            for (const file of files) {
                const fileText = await fileToBase64(file);
                const imageInfo = fileText.split(";base64,");
                chosenProductVariation.images.push(new ProductImageModel({
                    url: fileText,
                    byteLength: file.size,
                    isMain: false,
                    isActive: true,
                    imageInfo: imageInfo[1],
                }));
            }

            if (productVariationImageForm.hasUrl()) {
                chosenProductVariation.images.push(new ProductImageModel({
                    url: productVariationImageForm.url,
                    byteLength: 0,
                    isMain: false,
                    isActive: true,
                    imageInfo: productVariationImageForm.url,
                }));
            }

            const variationNormalized = ProductFormModel.normalizeVariationImages(chosenProductVariation)

            const newVariationImages = (variationNormalized.images || []).filter((img) => {
                return !img.id
            })

            try {
                if (!!newVariationImages.length) {
                    const totalVariationImageListSize = sumBy(newVariationImages, 'sizeMb')

                    if (totalVariationImageListSize < ProductImageFormModel.MAX_SIZE_MB) {
                        const imagesLinked = await productService.createProductImages(variationNormalized.id, newVariationImages)
                        this.productForm.setVariationImages(variationNormalized.skuCode, imagesLinked)
                    } else {
                        for (const img of newVariationImages) {
                            const imagesLinked = await productService.createProductImages(variationNormalized.id, [img])
                            this.productForm.setVariationImages(variationNormalized.skuCode, imagesLinked)
                        }
                    }
                }

                this.closeProductVariationImageSelectionModal()
            } catch (err) {
                this.$floatingAlert.error({
                    message: `Houve um problema ao tentar adicionar imagens na variação ${variationNormalized.skuCode}.`
                })
            }

            this.addingImagesToVariation = false
        },
        skuStatusHandler(sku) {
            return (bool) => {
                sku.isActive = bool;
            }
        },
        productStatusHandler(info) {
            this.productForm.isActive = info;
        },
        productPhysicalHandler(info) {
            this.productForm.isPhysical = info;
            this.productForm.isVirtual = !info;
        },
        productShowWithoutStockHandler(info) {
            this.productForm.showWithoutStock = info;
        },
        openModalUpdateVariationImages() {
            modalService.show(ID_MODAL_UPDATE_VARIATION_IMAGES)
        },
        closeModalUpdateVariationImages() {
            modalService.hide(ID_MODAL_UPDATE_VARIATION_IMAGES)
        },
        openProductMainImageSelection() {
            this.productMainImageForm.clear()
            document.getElementById("product-main-image-selection-input").value = "";
            modalService.show(ID_MODAL_PRODUCT_MAIN_IMAGE_SELECTION)
        },
        closeProductMainImageSelectionModal() {
            modalService.hide(ID_MODAL_PRODUCT_MAIN_IMAGE_SELECTION)
        },
        openProductVariationImageSelection(productVariation) {
            this.chosenProductVariation = productVariation
            this.productVariationImageForm.clear()
            document.getElementById("product-variation-image-selection-input").value = "";
            modalService.show(ID_MODAL_PRODUCT_VARIATION_IMAGE_SELECTION)
        },
        closeProductVariationImageSelectionModal() {
            modalService.hide(ID_MODAL_PRODUCT_VARIATION_IMAGE_SELECTION)
        },
        async getCategoryList() {
            this.loadingCategoryList = true

            if (!this.categoryList.length) {
                try {
                    const categories = await categoryService.getCategoryTree()
                    const categoryList = []

                    for (const cat of categories || []) {
                        categoryList.push(Object.assign({}, cat))

                        for (const child of cat.children || []) {
                            categoryList.push(Object.assign({}, child, { name: `${cat.name} > ${child.name}` }))

                            for (const grandchild of child.children || []) {
                                categoryList.push(Object.assign({}, grandchild, { name: `${cat.name} > ${child.name} > ${grandchild.name}` }))

                                for (const grandgrandchild of grandchild.children || []) {
                                    categoryList.push(Object.assign({}, grandgrandchild, { name: `${cat.name} > ${child.name} > ${grandchild.name} > ${grandgrandchild.name}` }))

                                    for (const grandgrandgrandchild of grandgrandchild.children || []) {
                                        categoryList.push(Object.assign({}, grandgrandgrandchild, { name: `${cat.name} > ${child.name} > ${grandchild.name} > ${grandgrandchild.name} > ${grandgrandgrandchild.name}` }))
                                    }
                                }
                            }
                        }
                    }

                    this.categoryList = uniqBy(categoryList, 'id')

                    this.productForm.categories.forEach((cat, index) => {
                        for (const catInList of this.categoryList) {
                            if (catInList.id == cat.id) {
                                // This makes sure the name being displayed in the list has the ">" 
                                // when showing subcategories deep in the hierarchy tree
                                this.productForm.categories[index].name = catInList.name;
                                return
                            }
                        }
                    })
                } catch (e) {
                    this.$floatingAlert.error({
                        title: 'Houve um problema ao listar as categorias',
                        message: e.message,
                    })
                }
            }

            this.loadingCategoryList = false
        },
        async getBrandList() {
            this.loadingBrandList = true

            if (!this.brandList.length) {
                try {
                    this.brandList = await brandService.getAllBrands()
                } catch (e) {
                    this.$floatingAlert.error({
                        title: 'Houve um problema ao listar as marcas',
                        message: e.message,
                    })
                }
            }

            this.loadingBrandList = false
        },
        async setMainImage(image) {
            image.updatingMainAttribute = true

            this.productForm.images.forEach((productImage) => {
                productImage.isMain = false;
            });

            image.isActive = true;
            image.isMain = true;

            if (image.hasId()) {
                const isMainObj = {
                    isMain: image.isMain,
                    isActive: true
                }

                try {
                    await productService.updateProductImageIsMainAttribute(this.productForm.getId(), image.id, isMainObj)
                } catch (e) {
                    this.$floatingAlert.error({
                        message: e.message,
                    })
                }
            }

            image.updatingMainAttribute = false;
        },
        createGrid(variationForm) {
            if (!this.productForm.hasSkuCode()) {
                this.$floatingAlert.error({
                    title: "SKU inválido",
                    message: "O Produto precisa ter um SKU válido para que as variações sejam criadas.",
                })

                return
            }

            const basicProductInfo = {
                isActive: true,
                skuCode: this.productForm.skuCode,
                costPrice: this.productForm.costPrice,
                listPrice: this.productForm.listPrice,
                sellPrice: this.productForm.sellPrice,
                ncmCode: this.productForm.ncmCode,
                eanCode: this.productForm.eanCode,
            }

            this.productForm.createVariationsFromProductVariationForm(basicProductInfo, variationForm)
        },
        toggleRawDescriptions(info) {
            this.rawDescriptions = info;
        },
        _focusTab(tabId) {
            $(`#product-form-tab a[href="${tabId}"]`).tab('show')
        }
    },
    computed: {
        ...mapState({
            subscriber: state => state.subscriber,
        }),
        channelHasPricePercentage() {
            return (channel) => {
                return !!channel.pricePercentage
            }
        },
        worksWithPriceUponRequest() {
            return (channel) => {
                return channel.enumChannel === ChannelEnum.Tray
            }
        },
        examplePriceVariation() {
            return (channel) => {
                if (!channel) {
                    return 0
                }

                if (!this.productForm.sellPrice) {
                    return 0
                }

                if (!channel.pricePercentage) {
                    return this.productForm.sellPrice || 0
                }

                if (!channel.priceDecimalsPreference) {
                    return (this.productForm.sellPrice * channel.pricePercentage) / 100
                }

                // Forces the priceDecimalsPreference in the result
                const resultVariation = (this.productForm.sellPrice * channel.pricePercentage) / 100
                const resultWithoutDecimals = parseInt(resultVariation, 10)
                let newResultWithDecimals = 0

                if (channel.priceDecimalsPreference !== '100') {
                    newResultWithDecimals = `${resultWithoutDecimals}.${channel.priceDecimalsPreference}`
                } else {
                    newResultWithDecimals = `${resultWithoutDecimals + 1}.00`
                }

                return parseFloat(newResultWithDecimals, 10);
            }
        },
    },
    watch: {
        product(val) {
            val.setChannels(this.channelList)
            this.productForm = val
            this.initialAllowImportInfo = cloneDeep(this.productForm.allowImportWrapper)
        },
    },
}
</script>

<style lang="scss" scoped>
.pending-warning {
    margin-top: 10px;
    font-size: 12px;
    color: var(--warning-fg);
    background: var(--warning-bg);
    border-radius: 4px;
    padding: 6px 10px;
    line-height: 1.4;
}

.valid-status {
    font-size: 13px;
    color: var(--success-fg);
    background: var(--success-bg);
    border-radius: 4px;
    padding: 6px 10px;
    line-height: 1.4;
}

.channel-validity-wrapper {
    border: 1px solid var(--border);
    border-radius: 8px;
    padding: 12px 14px;
    background: var(--surface-2);
    transition: border-color 0.2s, background 0.2s;
}

.channel-validity-wrapper.is-invalid {
    border-color: var(--danger-border);
    background: var(--danger-bg);
}

.channel-validity-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
}

.channel-validity-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--text-muted);
}

/* Ícone de info */
.info-icon-wrapper {
    position: relative;
    display: inline-flex;
}

.info-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--text-faint);
    color: var(--text-on-brand);
    font-size: 10px;
    font-weight: 700;
    cursor: pointer;
    user-select: none;
}

.info-icon:hover {
    background: var(--text-soft);
}

.info-tooltip {
    display: none;
    position: absolute;
    left: 22px;
    top: -8px;
    width: 280px;
    background: var(--surface-tooltip);
    color: var(--text-on-tooltip-soft);
    font-size: 12px;
    line-height: 1.5;
    padding: 10px 12px;
    border-radius: 6px;
    box-shadow: 0 4px 16px color-mix(in srgb, var(--shadow-ink) 20%, transparent);
    z-index: 100;
}

.info-tooltip p {
    margin: 6px 0 0 0;
}

.info-tooltip strong {
    color: var(--text-on-brand);
}

.info-tooltip em {
    color: var(--danger-on-dark);
    font-style: normal;
    font-weight: 600;
}

.info-icon-wrapper:hover .info-tooltip {
    display: block;
}

/* Warning quando inválido */
.invalid-warning {
    margin-top: 10px;
    font-size: 12px;
    color: var(--danger-fg);
    background: var(--danger-bg);
    border-radius: 4px;
    padding: 6px 10px;
    line-height: 1.4;
}


.muven-card {
    .muven-card-title {
        overflow: inherit;

        &>p {
            margin-bottom: 15px;

            &.product-name {
                font-size: 1.25em;
            }
        }
    }

    .rich-text-editor {
        height: 250px;
        margin-bottom: 44px;
    }
}

.tab-pane {
    label {
        .value {
            color: var(--text-soft);
        }
    }

    .channel-settings-container {
        margin: 0 15px 15px;
        border: 1px solid var(--border);

        .channel-settings-name-container {
            padding: 15px;
            text-transform: uppercase;
            font-weight: 600;
            letter-spacing: 1px;
            color: var(--text-soft);
            font-size: .9em;
            border-bottom: 1px solid var(--border);
            background-color: var(--surface-2);
        }

        .channel-settings-content {
            padding: 15px;
        }
    }

    .image-actions-container {
        margin: 0 15px 15px 15px;
    }

    .product-variations-container {
        .product-variation {
            padding: 16px;
            border-bottom: 1px solid var(--border-subtle);

            &:first-of-type {
                border-top: 1px solid var(--border-subtle);
            }

            &:last-of-type {
                border-bottom-color: transparent;
            }

            &:nth-of-type(odd) {
                background-color: color-mix(in srgb, var(--text-strong) 2.5%, transparent);
            }

            .product-variation-images-container {
                .variation-image {
                    position: relative;
                    display: inline-block;
                    height: 175px;
                    margin-top: 15px;
                    margin-right: 15px;

                    &:last-of-type {
                        margin-right: 0;
                    }

                    img {
                        height: 125px;
                        max-width: 150px;
                    }

                    .variation-image-dimension {
                        font-size: .9em;
                        position: absolute;
                        width: 100px;
                        bottom: 0;
                        left: 50%;
                        transform: translateX(-50%);
                    }

                    .icon-delete-image {
                        font-size: 1.5em;
                        color: var(--text-on-brand);
                        position: absolute;
                        top: -8px;
                        right: -12px;
                        height: 35px;
                        width: 35px;
                        padding: 6px;
                        border: 1px solid var(--surface-tooltip);
                        background-color: var(--surface-tooltip);
                        border-radius: 100%;

                        &:hover {
                            opacity: 1;
                            cursor: pointer;
                            background-color: var(--surface-tooltip-deep);
                            border-color: var(--surface-tooltip-deep);
                        }
                    }
                }
            }
        }
    }

    .product-image-list-container {
        display: flex;
        justify-content: flex-start;
        text-align: left;

        .no-images {
            background-color: var(--surface-2);
            padding: 15px;
            width: 100%;
        }

        .product-image-container {
            position: relative;
            width: 200px;
            height: 245px;
            margin-right: 15px;

            &:last-of-type {
                margin-right: 0;
            }

            img {
                width: 100%;
                max-height: 175px;
            }

            .icon-delete-image {
                font-size: 1.5em;
                color: var(--text-on-brand);
                position: absolute;
                top: -8px;
                right: -12px;
                height: 35px;
                width: 35px;
                padding: 6px;
                border: 1px solid var(--surface-tooltip);
                background-color: var(--surface-tooltip);
                border-radius: 100%;

                &:hover {
                    opacity: 1;
                    cursor: pointer;
                    background-color: var(--surface-tooltip-deep);
                    border-color: var(--surface-tooltip-deep);
                }
            }

            .btn {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                display: block;
                margin-top: 300px;
                bottom: 0;
                width: 100%;
            }
        }
    }
}
</style>